import { DEFAULT_ENTITY_AUTHOR } from '../core/constants';
import { EntityHeader } from 'framework/ui/layout';

const WasteHeader = () => <EntityHeader entityTitleSource="alias" defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;

export default WasteHeader;
